import { TabValue } from '../TabNavigation/types';

export const ROUTE_TO_TAB_MAP: Record<string, TabValue> = {
  details: 0,
  questions: 1,
  vacancies: 2,
  setup: 3,
  'hiring-team': 4,
  'internal-notes': 5,
  automations: 6,
  'activity-feed': 7,
};
